import React from 'react';

import { Box, Grid } from '@mui/material';
import { FieldValues } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';

import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import { useAppSelector } from 'app/hooks';
import OhsSelectField from 'global-components/form/fields/OhsSelectField';
import OhsUserLocalServices from 'user/OhsUserLocalServices';
import OhsIncidentLtiUtils from 'incident/lti/OhsIncidentLtiUtils';
import OhsMultipleSelectField from 'global-components/form/fields/OhsMultipleSelectField';

import { getGlobalFilter } from '../OhsTopFilterSlice';
import { OhsFilterList } from '../OhsFilterModels';

const useStyles = makeStyles()(() => ({
  root: {
    flexGrow: 1,
  },
  fieldWrap: {
    margin: '10px 0 10px 0',
  },
  filterContent: {
    width: '100%',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
interface Props {
  ohsFormSettings: OhsFormSettings<FieldValues>;
}

function OhsIncidentLtiFilters(props: Props) {
  const user = OhsUserLocalServices.getLocalOhsUser();
  const { classes } = useStyles();

  const filter = useAppSelector(getGlobalFilter) as OhsFilterList;
  const getWorkplaceLists = OhsIncidentLtiUtils.userWorkplaceOptions(user);
  const workplaceOptions = getWorkplaceLists.map((item: any) => ({
    name: item.name,
    value: item.id,
  }));

  const { currentWorkplace, yearOptions, roleOptions, roles, years } =
    props.ohsFormSettings.useFormMethods.getValues('incidentLtiModule');
  const selectedWp = getWorkplaceLists.find((x) => x.id === currentWorkplace);
  if (selectedWp) {
    const updatedFilter: OhsFilterList = {
      ...filter,
      incidentLtiModule: {
        ...(filter.incidentLtiModule ?? {}),
        roles,
        roleOptions,
        years,
        yearOptions,
      },
    };
    const ltiFilter = OhsIncidentLtiUtils.genLtiFilter(updatedFilter, selectedWp);
    props.ohsFormSettings.useFormMethods.setValue(
      'incidentLtiModule.targetTier',
      ltiFilter.incidentLtiModule.targetTier
    );
  }

  return (
    <Box className={classes.filterContent}>
      {user && user.tierNum === 3 && (
        <Grid item md={12} xs={12} className={classes.fieldWrap}>
          <OhsSelectField
            title="Workplace"
            id="incidentLtiModule.currentWorkplace"
            required
            options={workplaceOptions ?? []}
            ohsFormSettings={props.ohsFormSettings}
          />
        </Grid>
      )}
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsSelectField
          title="Sort By"
          id="incidentLtiModule.sort"
          required
          options={filter.incidentLtiModule?.tableSortKeyLists?.sortColAscDescOptions ?? []}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsMultipleSelectField
          title="Roles"
          id="incidentLtiModule.roles"
          required={false}
          options={(roleOptions ?? []).map((item: string) => ({ name: item, value: item }))}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
      <Grid item md={12} xs={12} className={classes.fieldWrap}>
        <OhsMultipleSelectField
          title="Years"
          id="incidentLtiModule.years"
          required={false}
          options={(yearOptions ?? []).map((item: string) => ({ name: item, value: item }))}
          ohsFormSettings={props.ohsFormSettings}
        />
      </Grid>
    </Box>
  );
}

export default OhsIncidentLtiFilters;
